import { render, staticRenderFns } from "./BorrarLesion.vue?vue&type=template&id=37355513"
import script from "./BorrarLesion.vue?vue&type=script&setup=true&lang=js"
export * from "./BorrarLesion.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports